export default "__VITE_ASSET__e39723b0__"